export enum PushNotificationServiceStatus {
    none = '',
    connected = 'Connected',
    reconnecting = 'Reconnecting',
    reconnected = 'Reconnected',
    disconnected = 'Disconnected',
}
